var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 9,
    fill: "#FF5F1B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.333 21.6667H21.6663C19.008 21.6667 16.8572 23.8417 16.8572 26.5001L16.833 55.5001C16.833 58.1584 19.008 60.3334 21.6663 60.3334H60.333C62.9913 60.3334 65.1663 58.1584 65.1663 55.5001V26.5001C65.1663 23.8417 62.9913 21.6667 60.333 21.6667ZM60.333 55.5001H21.6663V31.3334L40.9997 43.4167L60.333 31.3334V55.5001ZM40.9997 38.5834L21.6663 26.5001H60.333L40.9997 38.5834Z",
    fill: "#EC3337"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMailIcon);
export default __webpack_public_path__ + "static/media/red_mail_icon.c7c4f0cbbd5bc0d34aeb79db78c014e8.svg";
export { ForwardRef as ReactComponent };